import { render, staticRenderFns } from "./AddChildren.vue?vue&type=template&id=512c18e0&scoped=true&"
import script from "./AddChildren.vue?vue&type=script&lang=js&"
export * from "./AddChildren.vue?vue&type=script&lang=js&"
import style0 from "./AddChildren.vue?vue&type=style&index=0&id=512c18e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c18e0",
  null
  
)

export default component.exports